import type { Resource } from '../../';
export const country_countries_AE: Resource = {"default":"United Arab Emirates"};
